export default __webpack_public_path__ + "static/media/lightbulb.5a8e9425.svg";